import React from 'react';
import Hero from './Hero/Hero';
import CompanyOverview from './CompanyOverview/CompanyOverview';
import Sbs from './SideBySide/Sbs';
import MeetOurExpertTeam from './MeetOurExpertTeam/MeetOurExpertTeam';
import NavBar from './../../components/NavBar';
import { Footer } from '../../components/Footer/Footer';
import { useAuthentication } from '../../CustomHooks/useAuthentication';

export const AboutUs = () => {
  const [userId, isLoggedIn] = useAuthentication();

  return (
    <>
      <NavBar currentPath="About" userId={userId} />
      <div className="about-us-wrapper">
        <Hero />
        <CompanyOverview />
        <Sbs userId={userId} />
        <MeetOurExpertTeam />
      </div>
      <Footer currentPath="/about" userId={userId} />
    </>
  );
};
